import type React from 'react';

import LoaderLogo from '../../../../public/images/logo.svg';

const PageLoading = ({
  backgroundColor = '#FFC0BC',
}: {
  backgroundColor?: React.CSSProperties['backgroundColor'];
}) => {
  const injectStyles = `
  html {
    min-height: 100%;
  }
  body {
    display: block;
  }
  body,
  #__next {
    flex: 1;
  }
  html,
  body,
  #__next {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
  #__next {
    justify-content: center;
  }
  @keyframes pulse {
      20% { transform: translateY(-50%) scale(1) }
      80% { transform: translateY(-50%) scale(1.1) }
    }`;

  return (
    <>
      <style>{injectStyles}</style>
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: backgroundColor,
        }}
      >
        <LoaderLogo
          width={146}
          height={146}
          alt="logo"
          style={{
            position: 'absolute',
            top: '50%',
            animation: 'pulse 1s infinite',
            transform: 'translateY(-50%)',
          }}
        />
      </div>
    </>
  );
};

export default PageLoading;
